import { render, staticRenderFns } from "./modalChurn.vue?vue&type=template&id=1542311e&scoped=true"
import script from "./modalChurn.vue?vue&type=script&lang=js"
export * from "./modalChurn.vue?vue&type=script&lang=js"
import style0 from "./modalChurn.vue?vue&type=style&index=0&id=1542311e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1542311e",
  null
  
)

export default component.exports